import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import { apiClient } from '../../lib/api'
import { STATIC_ENDPOINTS } from './static.endpoints'

export interface NewsletterPayload {
  email: string
}

export interface NewsletterResponse {
  message: string
}

export interface NewsletterError {
  message: string
}

export interface ContactPayload {
  name: string
  email: string
  message: string
}

export interface ContactResponse {
  message: string
}

export interface ContactError {
  message: string
}

export const subscribeNewsletter = async (data: NewsletterPayload): Promise<NewsletterResponse> => {
  const response = await apiClient.post<NewsletterResponse>(STATIC_ENDPOINTS.NEWSLETTER_SUBSCRIBE, data)
  return response.data
}

export const contactUs = async (data: ContactPayload): Promise<ContactResponse> => {
  const response = await apiClient.post<ContactResponse>(STATIC_ENDPOINTS.CONTACT_US, data)
  return response.data
}

export const useSubscribeNewsletter = (
  options?: Omit<UseMutationOptions<NewsletterResponse, AxiosError<NewsletterError>, NewsletterPayload>, 'mutationFn'>,
) => {
  return useMutation({
    mutationFn: subscribeNewsletter,
    ...options,
  })
}

export const useContactUs = (
  options?: Omit<UseMutationOptions<ContactResponse, AxiosError<ContactError>, ContactPayload>, 'mutationFn'>,
) => {
  return useMutation({
    mutationFn: contactUs,
    ...options,
  })
}
